/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import _ from 'lodash';

const angularjsDeps = [
  '$analytics',
  '$compile',
  '$cookies',
  '$filter',
  '$location',
  '$q',
  '$sanitize',
  '$sce',
  '$scope',
  '$state',
  '$stateParams',
  '$timeout',
  '$transitions',
  '$uibModal',
  'AccessibleInertService',
  'AlertService',
  'CommentService',
  'CompileService',
  'ConfigService',
  'CookieAgreementService',
  'CourseService',
  'CourseTrackService',
  'DiscussionCategoryService',
  'DiscussionService',
  'EmbedlyService',
  'FeedStore',
  'GamificationService',
  'HomeFeedService',
  'LeaderboardService',
  'ImageDataService',
  'LightTesterErrorService',
  'MetaService',
  'PaginatorService',
  'ProgressBarService',
  'ProjectService',
  'SearchService',
  'ServiceByType',
  'ServerMessages',
  'StaticValuesService',
  'StatusService',
  'UploadService',
  'UserService',
  'commentEmojis',
  'stateStore',
];

const angularjsDependencyProviders = _.map(angularjsDeps, (dependency) => ({
  provide: dependency,
  useFactory: ($injector: any) => $injector.get(dependency),
  deps: ['$injector'],
}));

export default angularjsDependencyProviders;
